import { Component, Input, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { IVoteDocument } from '../../models/vote-document';
import { MatDialog } from '@angular/material/dialog';
import { materialSymbols } from '../../../../../shared/constants/material-symbols';
import { IFilePreview } from '../../../../../shared/models/file-preview';
import { FileDownloadUtility } from '../../../../../shared/utilities/blob-download-utility';
import { FilePreviewComponent } from '../../../../controls/file-preview/file-preview';

@Component({
    selector: 'app-view-vote-documents-popover',
    templateUrl: './view-vote-documents-popover.component.html',
    styleUrl: './view-vote-documents-popover.component.scss',
    standalone: false
})
export class ViewVoteDocumentsPopoverComponent {
  @ViewChild('viewVotePopover') viewVotePopover!: NgbPopover;
  @Input() id: string = 'view-vote-popover';
  @Input() popoverTitle: string = '';
  voteDocument?: IVoteDocument;

  closeSymbol: string = materialSymbols.close;

  constructor(
    public dialog: MatDialog
  ) {}

  public openPopover(voteDocument: IVoteDocument) : void {
    this.voteDocument = voteDocument;
    this.viewVotePopover.open();
  }

  public downloadDocument(): void {
    if (this.voteDocument && this.voteDocument.fileContent) {
        //const blobFile = response?.content;
        FileDownloadUtility.downloadbase64StringToBrowser(this.voteDocument.fileContent??this.voteDocument?.blobContent, this.voteDocument.fileName??this.voteDocument?.overview.metadata.filename);
        this.viewVotePopover.close();
    }
  }

  public previewDocument(): void {
    if (this.voteDocument && this.voteDocument.fileContent) {
      let filePreview: IFilePreview;
      //const blobFile = response?.content;

      filePreview = {
        fileName: this.voteDocument.fileName??this.voteDocument?.overview.metadata.filename,
        fileContent: this.voteDocument.fileContent??this.voteDocument?.blobContent as any,
        outlookMessage: this.voteDocument.outlookMessageDetails
      }
      this.viewVotePopover.close();
      this.dialog.open(FilePreviewComponent, {
        maxWidth: '75vw',
        maxHeight: '80vh',
        height: '100%',
        width: '100%',
        data: filePreview,
      });
    }
  }
}
